import React from "react";
import "./Main.css";

 export default function Zkani2() {
    return (
            <div className="zk-ani2">
                <h2 className="ani2">مصطلحات زكاة الأنعام</h2>
            <p>بنت مخاض: هي أنثى الإبل أتمت سنة واحدة ودخلت في الثانية، سميت بذلك لأن أمها لحقت بالمخاض وهي الحوامل الثانية</p>
            <hr></hr>
    <p>بنت لبون: أنثى الإبل التي أتمت سنتين ودخلت في الثالثة، سميت بذلك لأن أمها تكون وضعت غيرها في الغالب وصارت ذات لبن</p>
    <hr></hr>
    <p>حِقه: أنثى الإبل التي أتمت ثلاث سنين ودخلت الرابعة، سميت حِقة لأنها استحقت أن يطرقها الفحل</p>
    <hr></hr>
    <p>جذعة: أنثى الإبل التي أتمت أربع سنين ودخلت في الخامسة</p>
    <hr></hr>
    <p>تبيع: ما أتم من البقر سنة ودخل في الثانية، ذكراً كان أو أنثى</p>
    <hr></hr>
<p>مسنة: أنثى البقر التي أتمت سنتين ودخلت في الثالثة</p>
    </div>
    
    );
}